export default "__VITE_ASSET__B_ijf3_S__"